import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactRoutingModule } from './contact-routing.module';
import { SharedModule } from '../shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';

import { ContactDialogComponent } from './dialogs/contact-dialog/contact-dialog.component';
import { ContactFormComponent } from './components/contact-form/contact-form.component';

import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBarModule } from '@angular/material/snack-bar';

@NgModule({
	declarations: [
		ContactDialogComponent,
  ContactFormComponent
	],
	imports: [
		CommonModule,
		ContactRoutingModule,
		SharedModule,
        ReactiveFormsModule,
		MatButtonModule,
		MatDialogModule,
        MatInputModule,
        MatSnackBarModule
	],
	exports: [
		ContactDialogComponent
	]
})
export class ContactModule { }
